import { Input } from '@/components/ui/input';
import { FieldRow } from '@/components/common/FieldRow';
import { PhoneInputField } from '@/components/common/PhoneInputField';

export function ContactFields({ audience, values, errors, onChange, onBlur }) {
  return (
    <div className="grid gap-5">
      <FieldRow
        id="contact-name"
        label={`${audience} Name`}
        required
        error={errors.name}
      >
        <Input
          id="contact-name"
          type="text"
          value={values.name}
          onChange={(e) => onChange('name', e.target.value)}
          onBlur={() => onBlur('name')}
          autoComplete="name"
          className="cursor-text"
        />
      </FieldRow>

      <FieldRow
        id="contact-phone"
        label={`${audience} Phone Number`}
        required
        error={errors.phone}
      >
        <PhoneInputField
          id="contact-phone"
          value={values.phone}
          onChange={(v) => onChange('phone', v)}
          onBlur={() => onBlur('phone')}
          error={!!errors.phone}
        />
      </FieldRow>

      <FieldRow
        id="contact-email"
        label={`${audience} Email`}
        required
        error={errors.email}
      >
        <Input
          id="contact-email"
          type="email"
          value={values.email}
          onChange={(e) => onChange('email', e.target.value)}
          onBlur={() => onBlur('email')}
          autoComplete="email"
          placeholder="you@example.com"
          className="cursor-text"
        />
      </FieldRow>
    </div>
  );
}